<template>
  <div>
    <Index
      v-if="show === 'index'"
      :credentials="credentials"
      :meta="meta"
      :query="query"
      @find="find()"
      @sendDeleteCredential="sendDeleteCredential"
      @pagination="pagination($event)"
      @createCredential="createCredential"
      @showCredential="showCredential($event)"
    />

    <Show
      v-else @deletedCredential="show = 'index'"
      @toIndex="show = 'index'"
      @sendDeleteCredential="sendDeleteCredential"
      @editCredential="updateCredential"
      :credential="credential"
    />

    <ModalDeleteCredential
      v-model="showModalDeleteCredential"
      title="Excluir credencial"
      :credential="credential"
      @sendDeleteModel="deleteCredential"
    />

    <Modal v-model="showModalFormCredential" width="sm">
      <span slot="header">{{ titleCredentialForm }}</span>
      <FormCredential
        v-if="showModalFormCredential"
        :credential="credential"
        @cancel="showModalFormCredential = false"
        @saved="savedCredential($event)"
      />
    </Modal>
  </div>
</template>

<script>
  import Index from '@/components/credentials/container/Index'
  import FormCredential from '@/components/credentials/FormCredential'
  import Show from '@/components/credentials/container/Show'
  import Modal from '../shares/specialTag/Modal'
  import ModalDeleteCredential from '@/components/credentials/ModalDeleteCredential'
  import GetAccount from '@/mixins/GetAccount'
  import ModelMapper from '@/mixins/ModelMapper'

  export default {
    components: { FormCredential, Index, Modal, ModalDeleteCredential, Show },
    computed: {
      credentials() {
        return this.getModels || []
      }
    },
    created() {
      this.asyncTemplateSelect()
    },
    data() {
      return {
        credential: null,
        nameModel: 'Credential',
        show: 'index',
        showModalDeleteCredential: false,
        showModalFormCredential: false,
        titleCredentialForm: '',
      }
    },
    methods: {
      createCredential() {
        this.credential = null
        this.titleCredentialForm = 'Cadastrar credencial'
        this.showModalFormCredential = true
      },
      deleteCredential(credential) {
        this.asyncTemplateDelete(credential, {
          after: () => {
            this.showModalDeleteCredential = false
            this.show = 'index'
            this.find()
          }
        })
      },
      find() {
        this.asyncTemplateSelect()
      },
      savedCredential(credential) {
        this.find()
        this.showCredential(credential)
      },
      sendDeleteCredential(credential) {
        this.credential = credential
        this.showModalDeleteCredential = true
      },
      showCredential(credential) {
        this.showModalFormCredential = false
        this.credential = credential
        this.show = 'show'
      },
      updateCredential(credential) {
        this.titleCredentialForm = 'Editar credencial'
        this.credential = credential
        this.showModalFormCredential = true
      },
    },
    mixins: [GetAccount, ModelMapper],
    name: 'Container'
  }
</script>

<style scoped>

</style>
